/* jshint esnext: true */
import { $body, $document } from '../utils/environment';

import { closeAllOverlays } from '../global/overlays';

var instance = null;

/**
 * Initialize smoothstate
 * @return {Object} Smoothstate instance
 */
export function smoothState() {
    if (instance === null) {
        var route = '';
        var $el = $('#main');
        var options = {
            blacklist: 'a',
            forms: false,
            onStart: {
                // duration: 300, // Duration of our animation
                // render: ($container) => {
                //     // Close overlays that trigger navigation
                //     closeAllOverlays();
                //
                //     // Add your CSS animation reversing class
                //     toggleLoadingClasses();
                //
                //     // Restart your animation
                //     instance.restartCSSAnimations();
                // }
            },
            onReady: {
                // duration: 300,
                // render: function ($container, $newContent) {
                //     // Set proper template
                //     var doc = document.implementation.createHTMLDocument('');
                //     doc.documentElement.innerHTML = instance.cache[instance.href].doc;
                //     var template = doc.body.getAttribute('data-template');
                //     $body.data('template', template).attr('data-template', template);
                //
                //     // Inject the new content and reinit modules
                //     $container.html($newContent);
                //     $document.trigger('initModules.App');
                // }
            },
            onAfter: function($container, $newContent) {
                // toggleLoadingClasses();
                //
                // // Track Page Transition
                // if (window.ga && window.location.pathname) {
                //     window.ga('send', {
                //         hitType: 'pageview',
                //         page: window.location.pathname,
                //         location: instance.href,
                //         title: document.title
                //     });
                // }
                //
                // // Toggle tabs
                // let hash = window.location.hash;
                // hash && $('a[data-target="' + hash + '"]').tab('show');
            }
        };
        // $.smoothStateUtility.storePageIn = $.proxy(storePageIn, this);
        instance = $el.smoothState(options).data('smoothState');
    }
    return instance;
}

/**
 * Programmatically navigate to a local URL.
 * Mostly used by links outside the Smoothstate container.
 * @return {void}
 */
export function navigateTo(url) {
    if (instance !== null) {
        instance.load(url);
    }
}

/**
 * Toggle the loading classes for smooth transitions
 * @return {void}
 */
export function toggleLoadingClasses() {
    $body.toggleClass('is-page-state-loading is-page-state-inert');
    $body.addClass('is-page-state-loaded');
}
